import { defineComponent as _defineComponent } from 'vue'
import JobInventoryEditField from '@/components/tickets/JobInventoryEditField.vue'
import Inventory from '@/models/inventory'
import { useStore } from 'vuex-composition-helpers'
import { computed, ref, watch } from 'vue'
import { NormalizedInventory } from '@/store/modules/assets'


export default /*#__PURE__*/_defineComponent({
  __name: 'InventorySelectorField',
  props: {
    description: { default: null },
    errorSchema: { default: () => {
      return {}
    } },
    formData: null,
    businessUnitId: null,
    params: null,
    rootSchema: null,
    schema: null,
    title: null,
    uiSchema: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'change',
    value: {
      [INVENTORY_SUB_TYPE_KEY]?: number | null
      [QUANTITY_KEY]?: number | null
    }
  )
}), expose: any, slots: any, attrs: any }) {

const props = __props as { description: string | null, errorSchema: {
      [INVENTORY_SUB_TYPE_KEY]?: { errors?: string[] }
      [QUANTITY_KEY]?: { errors?: string[] }
      errors?: string[]
    }, formData: unknown, businessUnitId: string, params: unknown, rootSchema: unknown, schema: unknown, title: string | null, uiSchema: unknown, disabled: boolean }

const INVENTORY_SUB_TYPE_KEY = 'inventory_sub_type_id'
const QUANTITY_KEY = 'quantity'
const RESOURCE_TYPE_FILTER_ID_KEY = 'resource_type_activity_id'





// Error messages
const subTypeErrorMessages = computed<string[]>(() => {
  return (
    (props.errorSchema?.errors ||
      props.errorSchema?.[INVENTORY_SUB_TYPE_KEY]?.errors) ??
    []
  )
})
const quantityErrorMessages = computed<string[]>(() => {
  return props.errorSchema?.errors != null ||
    props.errorSchema?.[QUANTITY_KEY]?.errors != null
    ? ['Required']
    : []
})

// Selected Inventory Data flow
const mappedFormData = computed<Inventory>(() => {
  const mappedData: Inventory = new Inventory()

  mappedData.inventorySubTypeId = props.formData?.[INVENTORY_SUB_TYPE_KEY]
    ? props.formData?.[INVENTORY_SUB_TYPE_KEY]
    : null

  mappedData.quantity = props.formData?.[QUANTITY_KEY] ?? null

  return mappedData
})
const onUpdate = (event: {
  inventorySubTypeId: number | null
  quantity: number | null
}) => {
  const eventData = {}
  eventData[INVENTORY_SUB_TYPE_KEY] = event.inventorySubTypeId
  eventData[QUANTITY_KEY] = event.quantity ?? null

  emit('change', eventData)
}

// Selectable Inventory Options
const store = useStore()

const suggestedInventoriesByResourceTypeActivity = computed<
  (resourceTypeActivityId?: number | null) => NormalizedInventory[]
>(() => store.getters['assets/getInventoriesByResourceTypeActivity'])

const areAssetsLoading = computed(() => store.getters['assets/isLoading'])

const availableInventoryOptions = computed(() => {
  return suggestedInventoriesByResourceTypeActivity.value(
    props.schema?.[RESOURCE_TYPE_FILTER_ID_KEY] ?? null
  )
})

const reloadSelector = ref(0)

watch(
  availableInventoryOptions,
  (newInventoryOptions) => {
    if (
      !areAssetsLoading.value &&
      suggestedInventoriesByResourceTypeActivity.value(null).length > 0 &&
      props.formData?.[INVENTORY_SUB_TYPE_KEY] &&
      !newInventoryOptions?.some((i) =>
        i.assetConditions?.some(
          (c) => c.id === props.formData?.[INVENTORY_SUB_TYPE_KEY]
        )
      )
    ) {
      onUpdate({
        quantity: mappedFormData.value.quantity ?? null,
        inventorySubTypeId: null,
      })
      reloadSelector.value += 1 // ensures the selector popup is not showing inventory options that are no longer valid
    }
  },
  { immediate: true }
)

return { __sfc: true,INVENTORY_SUB_TYPE_KEY, QUANTITY_KEY, RESOURCE_TYPE_FILTER_ID_KEY, emit, props, subTypeErrorMessages, quantityErrorMessages, mappedFormData, onUpdate, store, suggestedInventoriesByResourceTypeActivity, areAssetsLoading, availableInventoryOptions, reloadSelector, JobInventoryEditField }
}

})